export default {
  pages: [
    {
      name: "Product",
      slug: "../products",
      id: 1,
      description: "Product details.",
      meta:{
        children: false,
        adminUsers: true,
        pharmacyUsers: false,
        reportsUsers: false,
       },
    },
    {
      name: "Pharmacies",
      slug: "../pharmacy",
      id: 2,
      description: "Pharmacy details.",
      meta:{
        children: false,
        adminUsers: true,
        pharmacyUsers: false,
        reportsUsers: false,
        },
    },
    {
      name: "Customers",
      slug: "../customer",
      id: 3,
      description: "Customer information",
      meta:{
        children: false,
        adminUsers: true,
        pharmacyUsers: false,
        reportsUsers: false,
        },
    },
    {
      name: "Contracts",
      slug: "../contract",
      id: 4,
      description:"Contract maintenance.",
      meta:{
        children: false,
        adminUsers: true,
        pharmacyUsers: false,
        reportsUsers: false,
        },
    },
    {
      name: "Reports",
      slug: "",
      id: 5,
      description: "Reports.",
      meta:{
        children: true,
        adminUsers: true,
        pharmacyUsers: false,
        reportsUsers: false,
        },
      reports: [
        {
        name: "Vouchers By Customer",
        slug: "../reports/VaccinationByCustomer",
        id: 7,
        description: "Vouchers for a customer",
        meta:{
          children: false,
          adminUsers: true,
          pharmacyUsers: false,
          reportsUsers: false,
          },
        },
        {
        name: "Vouchers By Pharmacy",
        slug: "../reports/VaccinationByPharmacy",
        id: 8,
        description: "Vouchers for a pharmacy",
        meta:{
          children: false,
          adminUsers: true,
          pharmacyUsers: true,
          reportsUsers: true,
          },
        },
        {
        name: "Finance - Customer",
        slug: "../reports/FinanceCustomer",
        id: 9,
        description: "Finance Vaccinations for a customer",
        meta:{
          children: false,
          adminUsers: true,
          pharmacyUsers: false,
          reportsUsers: true,
          },
        },
        {
        name: "Finance - Pharmacy",
        slug: "../reports/FinancePharmacy",
        id: 10,
        description: "Finance Vaccinations for a pharmacy",
        meta:{
          children: false,
          adminUsers: true,
          pharmacyUsers: false,
          reportsUsers: true,
          },
        },
        {
          name: "Finance - Customer Pharmacy",
          slug: "../reports/FinanceCustomerPharmacy",
          id: 18,
          description: "Finance Vaccinations for a pharmacy",
          meta:{
            children: false,
            adminUsers: true,
            pharmacyUsers: false,
            reportsUsers: true,
          },
        }
      ]
    },
    {
      name: "Vouchers",
      slug: "../vaccination",
      id: 6,
      description: "Vouchers",
      meta:{
        children: false,
        adminUsers: true,
        pharmacyUsers: true,
        reportsUsers: false,
        },
    },
    {
      name: "Vouchers",
      slug: "../vaccinationAdmin",
      id: 18,
      description: "Vouchers - Admin",
      meta:{
        children: false,
        adminUsers: false,
        pharmacyUsers: false,
        reportsUsers: false,
        },
    },  
    {
      name: "Pharmacy Report",
      slug: "../reports/VaccinationByPharmacy",
      id: 11,
      description: "Vaccinations for a pharmacy",
      meta:{
        children: false,
        adminUsers: false,
        pharmacyUsers: true,
        reportsUsers: false,
        },
    },
    {
      name: "Pharmacy User",
      slug: "../pharmacyUser",
      id: 12,
      description: "Pharmacy Users.",
      meta:{
        children: false,
        adminUsers: true,
        pharmacyUsers: false,
        reportsUsers: false,
        },
    },
    {
      name: "Voucher By Customer",
      slug: "../reports/VaccinationByCustomer",
      id: 13,
      description: "Vouchers for a customer",
      meta:{
        children: false,
        adminUsers: false,
        pharmacyUsers: false,
        reportsUsers: true,
      },
    },
    {
      name: "Voucher By Pharmacy",
      slug: "../reports/VaccinationByPharmacy",
      id: 14,
      description: "Vouchers for a pharmacy",
      meta:{
        children: false,
        adminUsers: false,
        pharmacyUsers: false,
        reportsUsers: true,
      },
    },
    {
      name: "Finance - Customer",
      slug: "../reports/FinanceCustomer",
      id: 15,
      description: "Finance Vouchers for a customer",
      meta:{
        children: false,
        adminUsers: false,
        pharmacyUsers: false,
        reportsUsers: true,
      },
    },
    {
      name: "Finance - Pharmacy",
      slug: "../reports/FinancePharmacy",
      id: 16,
      description: "Finance Vouchers for a pharmacy",
      meta:{
        children: false,
        adminUsers: false,
        pharmacyUsers: false,
        reportsUsers: true,
      },
    },
    {
      name: "Finance - Customer Pharmacy",
      slug: "../reports/FinanceCustomerPharmacy",
      id: 17,
      description: "Finance Vouchers for a pharmacy",
      meta:{
        children: false,
        adminUsers: false,
        pharmacyUsers: false,
        reportsUsers: true,
      },
    },
  ]
};
